// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import ManagedAccordionSection from "@insite/mobius/AccordionSection/ManagedAccordionSection";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import { StyledClickable } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
// import { linkAltStyles } from "@store/Themes/common/mixins/link"; // Greif
import { typographyInvertColorStyles } from "@store/Themes/common/mixins/typography";
// import { accordionFooterSectionProps } from "@store/Themes/common/props/accordionFooter"; // Greif
import useZoneIsActive from "@toolkit/Framework/Common/Hooks/useZoneIsActive";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, siteWidthStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

/* Greif Custom Code - Start */
import { linkStyles } from "@store/Themes/common/mixins/link";
import { accordionFooterSectionProps } from "@store/Themes/common/props/accordionFooter";
/* Greif Custom Code - End */

const enum fields {
    // Greif Removed Code - contentTitle
    firstColumnTitle = "firstColumnTitle",
    secondColumnTitle = "secondColumnTitle",
    thirdColumnTitle = "thirdColumnTitle",
    /* Greif Custom Code */
    fourthColumnTitle = "fourthColumnTitle",
    titleColor = "titleColor",
}

type Alignement = "left" | "center" | "right";

const baseLegalAlignStyles = (alignment: Alignement) => css`
    text-align: ${alignment};

    ul {
        text-align: ${alignment};
    }
`;

const legalAlignStyles = (alignment: Alignement) => css`
    ${baseLegalAlignStyles("center")}

    ${breakpoint("md")} {
        ${baseLegalAlignStyles(alignment)}
    }
`;

// Greif Removed Code - footerLinkStyles
/* Starter Custom Code */

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    // Greif Removed Code - widgetGridContainer
    // Greif Removed Code - logoGridItem
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    // Greif Removed Code - subscribeGridItem
    // Greif Removed Code - socialLinksGridItem
    // Greif Removed Code - siteMapLinksGridItem
    // Greif Removed Code - richContentGridItem
    // Greif Removed Code - logoWrapper
    // Starter Custom Code
    widgetWrapper?: InjectableCss;
    innerWrapper?: InjectableCss;
    wrapper?: InjectableCss;
    gridContainer?: GridContainerProps;
    columnsGridItem?: GridItemProps;
    columnsGridContainer?: GridContainerProps;
    // Greif Removed Code - columnTitle
    columnTitle?: TypographyPresentationProps;
    accordion?: AccordionPresentationProps;
    accordionSection?: AccordionSectionPresentationProps;
    contentGridItem?: GridItemProps;
    contentTitle?: TypographyPresentationProps;
    legalWrapper?: InjectableCss;
    hidden?: HiddenProps;
    // Greif Removed Code - separatorGridItem
    legalGridContainer?: GridContainerProps;
    legalLeftGridItem?: GridItemProps;
    legalRightGridItem?: GridItemProps;
    // Greif
    mainColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    leftColumnGridItem?: GridItemProps;
    accordionRightColumnGridItem?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetWrapper: {
        css: css`
            [href^="mailto:"] {
                word-break: break-word;
            }

            /* Fix CMS visual issues */
            [class^="ZoneStyle-"] {
                height: auto;
            }
        `,
    },
    innerWrapper: {
        css: siteWidthStyles(),
    },
    wrapper: {
        css: css`
            background-color: ${getColor("footer.main")}; /* Greif */

            ${({ theme }) => css`
                ${breakpointValues(theme.design.layout.spacing.content, ["padding-top", "padding-bottom"])}
                font-size: ${theme.design.typography.size.smaller};
            `}
        `,
    },
    leftColumnGridItem: {
        width: [12, 12, 6, 4, 4], // Greif
        css: css`
            flex-direction: column;
            padding-top: ${pxToRem(20)};
            ${breakpointValues([0, 0, pxToRem(40), pxToRem(80)], "padding-right")}
        `,
    },
    mainColumnGridItem: {
        width: [12, 12, 2, 2, 2],
        align: "top",
        css: css`
            flex-direction: column;
        `,
    },
    rightColumnGridItem: {
        width: [12, 12, 3, 2, 2],
        css: css`
            flex-direction: column;
        `,
    },
    legalWrapper: {
        css: css`
            padding: ${pxToRem(15, 0)};
            background-color: ${getColor("footer.alt")};
        `,
    },
    legalGridContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([10]), pxToRemArray([6]))}

            li ${StyledClickable} {
                ${linkStyles("footer.altContrast", null, false, true)}
                font-weight: ${x => x.theme.design.typography.weight.base};
            }
        `,
    },
    legalLeftGridItem: {
        width: [12, 12, 3, 3, 3],
        css: legalAlignStyles("left"),
    },
    legalRightGridItem: {
        width: [12, 12, 9, 9, 9],
        align: "middle",
        css: css`
            font-size: ${x => x.theme.design.typography.size.tiny};
            ${legalAlignStyles("left")};
        `,
    },
    hidden: {
        css: css`
            width: 100%;
        `,
    },
    columnsGridItem: {
        width: 12,
    },
    accordionSection: accordionFooterSectionProps,
    accordionRightColumnGridItem: {
        width: [12, 12, 3, 2, 2],
        css: css`
            flex-direction: column;
            padding-left: 0;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({
    id,
    extendedStyles,
    // Greif
    fields: { firstColumnTitle, secondColumnTitle, thirdColumnTitle, fourthColumnTitle, titleColor },
}) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));

    /* Greif Custom Code - Start */

    const columnTitleStyle = (): TypographyPresentationProps => ({
        forwardAs: "p",
        css: css`
            ${({ theme }) => css`
                ${spacingStyles(null, pxToRem(19))}
                color: ${titleColor};
                font-size: ${theme.design.typography.size.base};
                font-weight: ${theme.design.typography.weight.bold};
            `}
        `,
    });

    const accordionStyle: AccordionPresentationProps = {
        css: css`
            color: ${titleColor};
        `,
    };
    /* Greif Custom Code - End */

    return (
        <StyledWrapper {...styles.widgetWrapper}>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.innerWrapper}>
                    <GridContainer {...styles.gridContainer}>
                        {/* Greif Removed - contentGridItem */}
                        <GridItem {...styles.columnsGridItem}>
                            {/* Greif Custom Code - Start */}
                            <Hidden above="sm" {...styles.hidden}>
                                <Accordion headingLevel={6} {...accordionStyle}>
                                    <ManagedAccordionSection
                                        title={firstColumnTitle}
                                        uid="footer-accordion-1"
                                        {...styles.accordionSection}
                                    >
                                        <Zone zoneName="SecondColumn" contentId={id} />
                                    </ManagedAccordionSection>
                                    <ManagedAccordionSection
                                        title={secondColumnTitle}
                                        uid="footer-accordion-2"
                                        {...styles.accordionSection}
                                    >
                                        <Zone zoneName="ThirdColumn" contentId={id} />
                                    </ManagedAccordionSection>
                                    <ManagedAccordionSection
                                        title={thirdColumnTitle}
                                        uid="footer-accordion-3"
                                        {...styles.accordionSection}
                                    >
                                        <Zone zoneName="FourthColumn" contentId={id} />
                                    </ManagedAccordionSection>
                                </Accordion>
                                <GridItem {...styles.accordionRightColumnGridItem}>
                                    <Typography {...columnTitleStyle()}>{firstColumnTitle}</Typography>
                                    <Zone zoneName="FirstColumn" contentId={id} />
                                </GridItem>
                            </Hidden>
                            {/* Greif Custom Code - End */}
                            <Hidden below="md" {...styles.hidden}>
                                <GridContainer {...styles.columnsGridContainer}>
                                    <GridItem {...styles.leftColumnGridItem}>
                                        <Zone zoneName="FirstColumn" contentId={id} />
                                    </GridItem>
                                    <GridItem {...styles.mainColumnGridItem}>
                                        <Typography {...columnTitleStyle()}>{firstColumnTitle}</Typography>
                                        <Zone zoneName="SecondColumn" contentId={id} />
                                    </GridItem>
                                    <GridItem {...styles.mainColumnGridItem}>
                                        <Typography {...columnTitleStyle()}>{secondColumnTitle}</Typography>
                                        <Zone zoneName="ThirdColumn" contentId={id} />
                                    </GridItem>
                                    <GridItem {...styles.mainColumnGridItem}>
                                        <Typography {...columnTitleStyle()}>{thirdColumnTitle}</Typography>
                                        <Zone zoneName="FourthColumn" contentId={id} />
                                    </GridItem>
                                    <GridItem {...styles.rightColumnGridItem}>
                                        <Typography {...columnTitleStyle()}>{fourthColumnTitle}</Typography>
                                        <Zone zoneName="FifthColumn" contentId={id} />
                                    </GridItem>
                                </GridContainer>
                            </Hidden>
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            </StyledWrapper>
            <StyledWrapper {...styles.legalWrapper}>
                <StyledWrapper {...styles.innerWrapper}>
                    <GridContainer {...styles.legalGridContainer}>
                        <GridItem {...styles.legalLeftGridItem}>
                            <Zone zoneName="LegalLeft" contentId={id} />
                        </GridItem>
                        <GridItem {...styles.legalRightGridItem}>
                            <Zone zoneName="LegalRight" contentId={id} />
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],

        fieldDefinitions: [
            {
                name: fields.firstColumnTitle,
                displayName: "First Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.secondColumnTitle,
                displayName: "Second Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.thirdColumnTitle,
                displayName: "Third Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            /* Greif Custom Code - Start */
            {
                name: fields.fourthColumnTitle,
                displayName: "Fourth Title",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.titleColor,
                displayName: "Title Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            /* Greif Custom Code - End */
        ],
    },
};

export default footerContainer;
